<template>
  <div>
    <FormGroup
      label="Give your review a title"
      :help="helperText"
      required
    >
      <Input
        v-model="localValue"
        placeholder="Summarize your experience in a few words"
        class="w-full text-lg"
        :maxlength="maxLength"
      />
      <small class="text-gray-500">{{ maxLength - localValue.length }} characters remaining</small>
    </FormGroup>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: string
  maxLength: number
  helperText?: string
}>()
const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()
const localValue = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value)
})
</script>
